<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDistinte > 0"
      item-key="_id"
      :headers="headers"
      :items="distinte"
      :options.sync="options"
      :server-items-length="totaleDistinte"
      :loading="loading"
      class="elevation-1"
      @item-expanded="itemExpanded"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :show-expand="true"
      dense
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ title || 'Gestione distinta base' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="success" dark class="mb-2 mr-5" @click="onNuovaDistinta">Nuova Distinta</v-btn>
          <dialog-errore :show="dialogErrore" :title="errorTitle" :message="errorMessage" @dialogConfirm="dialogErrore = false"/>
        </v-toolbar>
        <filtri :filtraTipiDistintaBase="filtroTipiDistintaBase" @ricerca="onRicerca"/>
      </template>
      <template v-slot:[`item.data`]="{ item }">
        {{ item.data | date }}
      </template>
      
      <template v-slot:[`item.dataModifica`]="{ item }">
        {{ (item.editInfo.dataModifica || item.editInfo.dataCreazione) | dateTime }}
      </template>    
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item, false)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" @click="stampaDistintaBase(item)">mdi-printer-outline</v-icon>
<!--         <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="editItem(item, false)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
          </template>
          <span>Modifica la distinta base</span>
        </v-tooltip>      
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="editItem(item, true)" v-bind="attrs" v-on="on">mdi-archive-eye-outline</v-icon>
          </template>
          <span>Dettaglio della distinta base</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="stampaDistintaBase(item)" v-bind="attrs" v-on="on">mdi-printer-outline</v-icon>
          </template>
          <span>Stampa distinta base</span>
        </v-tooltip> -->
      </template>
      <template v-slot:no-data>
        Nessun dato disponibile
      </template>
<!--       <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="articoliSelected">
           <v-tabs dense v-model="tab[item.numeroOdp]">
            <v-tab key="dettaglioDistinta" class="articoliSelected">Dettaglio distinta base</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab[item.numeroOdp]">
            <v-tab-item key="dettaglioDistinta">
              <dettaglio-distinta :item="item" @refresh="getDataFromApi"/>
            </v-tab-item>           
          </v-tabs-items>
        </td>
      </template>    --> 
    </v-data-table>
    <distinta-base :showDialog="showDistintaBase" :idDocumento="idDistintaBase" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <!-- <speed-dial @comando="onSpeedDialogComando"/> -->
 <!--    <distintaBase-acquisto :showDialog="showDistintaBaseAcquisto" :idDistintaBase="idDistintaBase" :filtraTipiDistintaBase="filtraTipiDistintaBase" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <distintaBase-assemblaggio :showDialog="showDistintaBaseAssemblaggio" :idDistintaBase="idDistintaBase" :filtraTipiDistintaBase="filtraTipiDistintaBase" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <distintaBase-produzione :showDialog="showDistintaBaseProduzione" :idDistintaBase="idDistintaBase" :filtraTipiDistintaBase="filtraTipiDistintaBase" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
 -->
  </div>
</template>

<script>
  import { dynamicSortMultiple, getAnnoRiferimento } from '@/components/helpers.js'
  import DialogErrore from '@/components/dialogErrore'
  // import DialogStampa from '@/components/dialogStampa'
  // import SpeedDial from './speedDial.vue'
  import Filtri from './testate_filtri'
/*   import DistintaBaseAcquisto from './edit/acquisto'
  import DistintaBaseAssemblaggio from './edit/assemblaggio'
  import DistintaBaseProduzione from './edit/produzione' */
/*   import DettaglioDistinta from './dettaglioDistinta/indexTab' */
  import DistintaBase from './dettaglioDistinta'
  import documenti from '@/services/documentiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import moment from 'moment'
  import distinte from '@/services/distintaBaseService.js'
  import etichetteService from '@/services/etichetteService.js'
  import reporting from '@/services/reportingService.js'
  const labelsPath = window.appConfig.VUE_APP_MOL_S_LABELS

  export default {
    components: {
      // DettaglioDistinta,
      DistintaBase,
      DialogErrore,
      Filtri
      // SpeedDial,
      // DialogStampa
/*       DistintaBaseAcquisto,
      DistintaBaseAssemblaggio,
      DistintaBaseProduzione */
      // Recapiti
    },
    props: {
      filtraTipiDistintaBase: Array,
      title: String
    },
    data () {
      return {
        totaleDistinte: 0,
        distinte: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Codice', value: '_id'},
          { text: 'Descrizione', value: 'custom.info'},
          { text: 'Riferimento', value: 'custom.riferimento' },
          { text: 'Associati', value: 'associati'},
          { text: 'Stato', value: 'stato.descrizione' },
          { text: 'Data', value: 'data' },
          { text: 'Data Modifica', value: 'dataModifica' },      
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: [],
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false,
        // salta: 0,
        tipoStampa: '',
        report: '',
        isModuloA4: false,
        errorTitle: 'Errore aggiornamento DistintaBase',
        errorMessage: '',
        showDialogMultiple: false,
        showDettaglioFattura: false,
        triggerUpdate: 1,
        triggerDettaglio: 1,
        idDistintaBase: null,
        showDistintaBaseAcquisto: false,
        showDistintaBaseAssemblaggio: false,
        showDistintaBaseProduzione: false,
        readOnly: false,
        distintaBaseCollegato: {},
        showDistintaBase: false
      }
    },
    async created() {
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
      await this.getDefaultItem()
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuova DistintaBase' : 'Modifica DistintaBase'
      },
      distinteSaved() {
        return this.$store.getters['distinte/saved']
      },
      testataAperta() {
        return this.$store.getters['distinte/page'] === 'testata'
      },
      refreshList() {
        // console.log('refreshList')
        return this.$store.getters['distinte/refreshTestata']
      },
      distinteSorted() {
        const els = this.distinte
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted
      },
      totaleEtichette() {
        const elSel = this.selected
        if (elSel.length > 0) {
          const totaleAnagrafica = _.sum(elSel.map(x => x.qtaAnagrafica))
          const totaleDistinte = _.sum(elSel.map(x => x.qtaDistinteBase))
          return { totaleAnagrafica, totaleDistinte }
        } else {
          return { totaleAnagrafica: 0, totaleDistinte: 0 }
        }
      },
      filtroTipiDistintaBase() {
        return this.filtraTipiDistintaBase && this.filtraTipiDistintaBase.length > 0 ? this.filtraTipiDistintaBase.map(x => x.tipoDistintaBase) : []
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async distinteSaved(value) {
        if (value && this.testataAperta) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          this.options.page = 1
          await this.getDataFromApi()
          this.$store.commit('distinte/CLEAR_REFRESH', 'testata')
        }
      },
      async filtraTipiDistintaBase() {
        await this.getDataFromApi()
      }
    },
    /*     async created() {
      await this.getDefaultItem()
    }, */
    async mounted () {
      // await this.getDataFromApi()
/*       var numeroDistintaBase = this.$route.query.num
      console.log('numeroDistintaBase', numeroDistintaBase) */
    },
    methods: {
      async onNuovaDistinta() {
        this.idDistintaBase = null
        this.showDistintaBase = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDistintaBase = false
      },
      async onAcquisto() {
        this.showDistintaBaseAcquisto = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDistintaBaseAcquisto = false
      },
      async onAssemblaggio() {
        this.showDistintaBaseAssemblaggio = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDistintaBaseAssemblaggio = false
      },
      async onProduzione() {
        this.showDistintaBaseProduzione = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDistintaBaseProduzione = false
      },
      async itemExpanded({ item, value }) {
        if (value) {
          // await this.aggiornaCollegato(item)
        }
      },      

      async getDefaultItem() {
        this.defaultItem = {} // rimettere await distinte.getModello('xxx')
        this.defaultItem.data = new Date()
      },
      async stampaDistintaBase(item) {
        const result = await reporting.stampaDistintaBase(this.$router, item, true, true)
        if (result.error) {
        }
      },  
      async onRicerca(filtri) {
        this.filtri = filtri
        this.options.page = 1
        await this.getDataFromApi()
      },
      async getDataFromApi () {
       try {
          this.loading = true
          const filtri = { ...this.filtri }
          filtri.tipoDocumento = ['distintaBase'] // (!filtri.tipoLotto || filtri.tipoLotto.length === 0) ? ['distintaBase'] : filtri.tipoLotto
          const data = await documenti.getFilteredDocumentHeaders(filtri, this.options)

          this.distinteRaw = data && data.total_rows > 0 ? data.rows : []
          let docs = this.datiVisualizzazione(this.distinteRaw)

          this.distinte = docs 
          this.totaleDistinte = data.total_rows
        } catch(err) {
          this.distinte = []
          this.totaleDistinte = 0
        } finally {
          this.loading = false
        }
      },
      async dettaglioItem (item) {
        /*         this.editedIndex = this.distinte.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('distinte/SET_CHIAVE', this.editedItem)
        this.$emit('apriDettaglio', this.editedItem) */

        this.idDistintaBase = item._id
        this.showDettaglioFattura = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDettaglioFattura = false

      },
      async editItem (item, readonly) {
        this.idDistintaBase = item._id
        this.showDistintaBase = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDistintaBase = false
/*         this.idDistintaBase = item._id
        this.readOnly = readonly
        this.showEditDistintaBase = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDistintaBase = false      */   
/*         this.editedIndex = this.distinte.indexOf(item)
        this.editedItem = await distinte.getDistintaBase(item._id)
        await this.completaAppoggio()
        this.$store.commit('distinte/SET_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      async completaAppoggio() {
        let itm = this.editedItem
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDistintaBase.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDistintaBase.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDistintaBase.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDistintaBase.infoPagamento)
        _.set(itm,'appoggio.tipoDistintaBase', itm.tipoDistintaBase)
        // const clienteId =  _.get(itm.anagrafica, 'cliente.codice', '') || _.get(itm.anagrafica, 'fornitore.codice', '')
        // const clifor = await clienti.getCliente(clienteId)
        const clifor = _.get(itm.anagrafica, 'cliente', '') || _.get(itm.anagrafica, 'fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      },      
      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async save () {
        this.$store.commit('distinte/CLEAR_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['distinte/distintaBase']
        if (this.editedIndex > -1) {
          // verificare
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteModifica = this.$store.getters.utente
          Object.assign(this.distinte[this.editedIndex], this.editedItem)
          if (!await distinte.aggiornaDistintaBase(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          const numeratore = this.editedItem.tipoDistintaBase.numeratore
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteCreazione = this.$store.getters.utente
          // sarebbe meglio mettere il numeratore su distinte, ma finchè non c'è molecular fa troppi giri ....
          const annoRiferimento = getAnnoRiferimento(this.editedItem.data) // this.editedItem.data.getFullYear()
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          this.editedItem.codice = numero
          this.editedItem._id = numero
          this.distinte.push(this.editedItem)
          if (!await distinte.creaDistintaBase(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        }
        this.editedItem = null
        this.editedIndex = -1
        this.close()
        // va fatto il refresh della lista per prendere gli aggiornamenti
        await this.getDataFromApi()
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editItem (item)
/*         this.editedIndex = this.distinte.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('distinte/SET_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      datiVisualizzazione(distinte) {
        const elaborati = distinte.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = el.anagrafica && ((el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)) || ''
          return { ...el, c_nominativo: nominativo }
        })
        return elaborati
      },
      deleteDatiVisualizzazione(distintaBase) {
        let locDistintaBase = {...distintaBase}
        delete locDistintaBase.c_nominativo
        delete locDistintaBase.appoggio
        return locDistintaBase
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'stampa-etichette':
            const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
/*             this.tipoStampa = impostazioni.tipo
            this.report = impostazioni.report
            this.isModuloA4 = impostazioni.tipo === 'pdf' */
            this.dialogStampa = true
            break
          default:
            break
        }
      },
      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta, tipoStampa, report) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        // this.salta = salta
        this.dialogStampa = false
        const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'distintaBase'
        const distinte = this.selected
        for (let mm of distinte) {
          const filtriAggiuntivi = [{
            applicazione: 'distinte',
            chiave: 'riferimento.id',
            testo: mm.riferimento.id
          }]
          const parametri = {
            articoli: true,
            filtri: filtriAggiuntivi,
            gruppi: [],
            tipoQuantita
          }
          const filtro = {
            start: moment(mm.data).startOf('day').format('YYYYMMDD'),
            end: moment(mm.data).endOf('day').format('YYYYMMDD')
          }
          const filtroElementi = { filtro, parametri }
          const src = `${labelsPath}/${tipoStampa}/${report}?elm=${btoa(JSON.stringify(filtroElementi))}${salta ? '&sk=' + salta : ''}${tipoQuantita ? '&tpq=' + tipoQuantita : ''}`
          const printResult = await etichetteService.stampaDiretta(tipoStampa, src)
          if (printResult.status && printResult.status === 'error') {
            this.errorTitle = ' Errore stampa etichette'
            this.errorMessage = printResult.error
            this.dialogErrore = true
          }
        }
        this.annullaSelezione()
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

  td.td-distintaBase-selected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
